import { render, staticRenderFns } from "./organizati.vue?vue&type=template&id=b6ee3346&scoped=true"
import script from "./organizati.vue?vue&type=script&lang=js"
export * from "./organizati.vue?vue&type=script&lang=js"
import style0 from "./organizati.vue?vue&type=style&index=0&id=b6ee3346&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ee3346",
  null
  
)

export default component.exports